export default __webpack_public_path__ + "static/media/3652d7df-f4e3-4d89-bb8d-4e8f646b5e6f.eceb87db.woff2";